import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'epochToLocalTime'
})
export class EpochToLocalTimePipe implements PipeTransform {
  transform(epochTime: number): string {
    if (!epochTime) return ''; 

    const date = new Date(epochTime);
    return date.toLocaleString();
  }
}
